/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    PageTagIdDetailsDto,
    ReadyForMarketBottleGroupDataDto,
    Resource,
    TagId,
    TagStatusDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class CentralTaggingControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        changeStatusTagId(
                    id: string
                , 
                queryParams: {
                    status: string
                }
    ): Observable<TagId> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/status/${id}`;

            return this._httpClient.put<TagId>(url, requestBody, requestOptions);
    }


        changeStatusTagIds(
                
                queryParams: {
                    status: string
                }
                    
                    , 
                    requestBody: Array<string>
    ): Observable<Array<TagId>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/tagging/status`;

            return this._httpClient.put<Array<TagId>>(url, requestBody, requestOptions);
    }


        checkTag(
                    tid: string
                , 
                queryParams: {
                    groupId: number
                }
    ): Observable<TagStatusDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/tag/${tid}/status`;

            return this._httpClient.get<TagStatusDto>(url, requestOptions);
    }


        generateTagIds(
                    numberOfIds: number,
                    type: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<Array<TagId>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/${type}/${numberOfIds}`;

            return this._httpClient.post<Array<TagId>>(url, requestBody, requestOptions);
    }


        generateTagIdsForBottleBatch(
                    bottleBatchId: number,
                    type: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<Array<TagId>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/batch/${type}/${bottleBatchId}`;

            return this._httpClient.post<Array<TagId>>(url, requestBody, requestOptions);
    }


        getResourceByTid(
                    tid: string
    ): Observable<Resource> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/scan/${tid}`;

            return this._httpClient.get<Resource>(url, requestOptions);
    }


        getTagIdById(
                    id: string
    ): Observable<TagId> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/${id}`;

            return this._httpClient.get<TagId>(url, requestOptions);
    }


        getTagIdPage(
                
                queryParams: {
                    status?: string,
                    type?: string,
                    idLike?: string,
                    wineryId?: string,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageTagIdDetailsDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/page`;

            return this._httpClient.get<PageTagIdDetailsDto>(url, requestOptions);
    }


        getTagIds(
    ): Observable<Array<TagId>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging`;

            return this._httpClient.get<Array<TagId>>(url, requestOptions);
    }


        tagIdExists(
                    tagId: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/exists/${tagId}`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        tagIdIsOfType(
                    tagId: string,
                    type: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/tagging/type/${type}/${tagId}`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        verifyGroupBottles(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number,
                    producerAddress: string,
                    productionAddress: string
                }
                    , 
                    
                    requestBody: ReadyForMarketBottleGroupDataDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/tagging/${bottleBatchId}/bottlegroup/${bottleGroupId}/status/verify`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


}

